var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"center"},[_c('p',[_vm._v("Do you want to logout?")]),_c('i',{staticClass:"fa fa-close close-icon",on:{"click":_vm.closeSignoutPrompt}})]),_c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"signout-btn",on:{"click":_vm.handleSignout}},[_vm._v("Logout")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }